const deleteReaction = (reactionID) => 
`mutation MyMutation3 {
  deleteReaction(id: "${reactionID}") {
    id
    postID
  }
}`;

export default deleteReaction;